export const ShopActionTypes = {
   UPDATE_COLLECTIONS: "UPDATE_COLLECTIONS"
 };
